import { t } from '@lingui/macro'
import { Tab, Tabs } from '@material-ui/core'
import { useAutorun } from '@speedlo/hooks'
import { observable } from 'mobx'
import { observer, useLocalStore } from 'mobx-react-lite'
import React from 'react'
import { SegmentKey } from 'shopify-payment-core'

import { useAccountMap } from '../hooks/useAccountMap'
import { i18n } from '../i18n'

interface IProps {
  selected: Maybe<ID>
  onNavigate(accountId: ID): void
  segmentKey: SegmentKey
}

const ADMIN_TAB = 'ADMIN'

const openTabs = observable.set<ID>()

export const SwitchBarAdmin = observer<IProps>(
  ({ selected, onNavigate: onChange, segmentKey }) => {
    const [accounts] = useAccountMap(segmentKey)

    const state = useLocalStore(
      source => ({
        get selectedTab() {
          if (source.selected && accounts.has(source.selected)) {
            return source.selected
          }
          return ADMIN_TAB
        },
      }),
      { selected },
    )

    useAutorun(() => {
      if (state.selectedTab !== ADMIN_TAB) {
        openTabs.add(state.selectedTab)
      }
    })

    return (
      <Tabs
        variant="scrollable"
        value={state.selectedTab}
        onChange={(ev, value) => {
          if (value === ADMIN_TAB) {
            onChange('')
          } else {
            onChange(value)
          }
        }}
      >
        <Tab label={i18n._(t`Administrace`)} value={ADMIN_TAB} />
        {Array.from(openTabs).map(id => {
          const account = accounts.get(id)
          if (!account) {
            return null
          }
          return <Tab key={id} label={account.shopName} value={id} />
        })}
      </Tabs>
    )
  },
)
